export default "__VITE_PUBLIC_ASSET__ae37a87b__"